var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.disableButton ? 'span' : 'router-link',{tag:"router-link",attrs:{"to":_vm.routeObj}},[_c('v-btn',{attrs:{"color":"secondary","data-testid":"viewAccountButton","type":"button","x-small":"","disabled":_vm.disableButton}},[_vm._v(" View ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }